// Internal link removal
navLinkRemoval = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  console.log($(this).attr('data-url'));
}

var navLinks = document.getElementsByClassName('no-href');
for (var i=0; i < navLinks.length; i++) {
  navLinks.item(i).onclick = navLinkRemoval;
}

document.addEventListener('quizKitAddToCartSuccess', function (e) {
  const customAddToCart = new CustomEvent("product:added", {
    bubbles: true,
    detail: { quantity: 1 }
  });
  
  document.dispatchEvent(customAddToCart)
}, false);

// Accordion
(() => {
  document.addEventListener(
    'toggle',
    (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement)) return;
      if (!opened.open) return;

      document.querySelectorAll('details[open]').forEach((d) => {
        if (d !== opened) d.open = false;
      });
    },
    true
  );
})();